<template>
  <div>
    <div v-if="formtype === 'advanced'">
      <h3>Thank you for your application.</h3>
      <div>A confirmation will be sent to your e-mail address shortly.</div>
      <br>
      <br>
    </div>
    <div v-else-if="formtype === 'advanced-online'">
      <h3>Thank you for your registration.</h3>
      <div>A confirmation will be sent to your e-mail address soon.</div>
      <br>
      <br>
    </div>
    <div v-else-if="formtype === 'anniversary'">
      <h3>Thank you for your registration.</h3>
      <div>A confirmation will be sent to your e-mail address soon.</div>
      <br>
      <br>
      <h3>Vielen Dank für Ihre Anmeldung!</h3>
      <div>Eine Bestätigung geht Ihnen in Kürze per E-Mail zu.</div>
      <br>
      <br>
    </div>
    <div v-else>
      <h3>{{ $t('ui.thankyou') }}</h3>
      <div>{{ $t('ui.thankyou.message') }}</div>
      <br>
      <br>
    </div>
  </div>
</template>

<script>

export default {
  name: 'thankyou',
  components: {
  },
  computed: {
    formtype () {
      return this.$store.state.formtype
    }
  }
}
</script>

<style>

</style>
